// Item.tsx
import { CustomerPaymentMethod } from '@@types'
import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

import useSBPBanks from '@shared/hooks/useSBPBanks'
import { getPaymentMethodLogo } from '@shared/lib/paymentMethodLogos'
import Radio from '@shared/ui/radio'

import styles from './styles.module.scss'

type Props = {
  data: CustomerPaymentMethod | null;
  isSelected: boolean;
  onSelect: () => void;
  type?: 'new-card' | 'new-sbp';
};

export default function Item ({ data, isSelected, onSelect, type }: Props) {
  const isNewCard = data === null && type === 'new-card'
  const isNewSBP = data === null && type === 'new-sbp'
  const { t: to } = useTranslation('order')
  const { staticBanks } = useSBPBanks()
  
  let iconSrc = '/icons/card.svg'
  let label = ''
  let isBankLogo = false
  let sbpBadge = false

  if (isNewCard) {
    iconSrc = '/icons/payments/crosshair.svg'
    label = to('new_card')
  } 
  else if (isNewSBP) {
    iconSrc = getPaymentMethodLogo('sbp')
    label = to('new_sbp')
    isBankLogo = true // используем img для отображения
  } 
  else if (data?.type === 'sbp') {
    // Для СБП находим банк по schema (формат: bank100000000111)
    const bank = staticBanks.find((b) => b.schema === `bank${data.last}`)
    
    if (bank) {
      iconSrc = bank.logo
      label = bank.name
      isBankLogo = true
    }
    else {
      iconSrc = getPaymentMethodLogo('sbp')
      label = data.last ? `СБП (${data.last})` : 'СБП'
    }
    sbpBadge = true
  }
  else if (data) {
    iconSrc = getPaymentMethodLogo(data.card)
    label = `${to('card')} ****${data?.last}`
  }

  return (
    <div className={styles.item} onClick={onSelect} role="button" tabIndex={0}>
      <div className={styles.item__iconContainer}>
        {isBankLogo ? (
          <img className={styles.item__icon} src={iconSrc} alt={label} />
        ) : (
          <ReactSVG className={styles.item__iconWrapper} src={iconSrc} wrapper="span" />
        )}
        {sbpBadge && isBankLogo && (
          <img
            className={styles['item__icon--sbp']}
            src={getPaymentMethodLogo('sbp')}
            alt="СБП"
          />
        )}
      </div>
      <p>{label}</p>
      <Radio checked={isSelected} onChange={onSelect} />
    </div>
  )
}